'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'bugs';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e4d0';
var svgPathData = 'M454.2 171.3c5.9-4.6 14.3-4.5 20.2 .5 5.9 5 7.2 13.4 3.6 19.9l-1.8 2.7-29.7 34.6c33.2 11.1 58.3 39.8 64.2 75l33.3 0c8.8 0 16 7.2 16 16 0 8.8-7.2 16-16 16l-32 0 0 64 32 0c8.8 0 16 7.2 16 16 0 8.8-7.2 16-16 16l-33.4 0c-7.6 45.4-47 80-94.6 80s-87-34.6-94.6-80L288 432c-8.8 0-16-7.2-16-16 0-8.8 7.2-16 16-16l32 0 0-64-32 0c-8.8 0-16-7.2-16-16 0-8.8 7.2-16 16-16l33.3 0c5.9-35.2 31-63.9 64.2-75l-29.7-34.6c-5.7-6.7-5-16.8 1.8-22.6 6.7-5.7 16.8-4.9 22.6 1.7l35.8 41.8 35.8-41.8 2.3-2.2zM416 256c-35.3 0-64 28.7-64 64l0 96c0 35.3 28.7 64 64 64s64-28.7 64-64l0-96c0-35.3-28.7-64-64-64zM198.2-20.7c5.9-4.6 14.4-4.5 20.2 .5 5.9 5 7.2 13.4 3.6 19.9L220.2 2.4 190.5 37c33.2 11.1 58.3 39.8 64.2 75l33.3 0c8.8 0 16 7.2 16 16 0 8.8-7.2 16-16 16l-32 0 0 64 32 0c8.8 0 16 7.2 16 16 0 8.8-7.2 16-16 16l-33.4 0c-7.6 45.4-47 80-94.6 80s-87-34.6-94.6-80L32 240c-8.8 0-16-7.2-16-16 0-8.8 7.2-16 16-16l32 0 0-64-32 0c-8.8 0-16-7.2-16-16 0-8.8 7.2-16 16-16l33.3 0c5.9-35.2 31-63.9 64.2-75L99.8 2.4c-5.7-6.7-5-16.8 1.7-22.6 6.7-5.7 16.8-4.9 22.6 1.7l35.8 41.8 35.8-41.8 2.3-2.2zM160 64c-35.3 0-64 28.7-64 64l0 96c0 35.3 28.7 64 64 64s64-28.7 64-64l0-96c0-35.3-28.7-64-64-64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBugs = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;